import {
    LayoutDashboard,
    Boxes,
    LineChart,
    Warehouse,
    Users,
    Truck,
    ShoppingBag,
    Receipt,
    Wallet,
    ShoppingCart,
    BarChart3,
    Sparkles,
    UserCog,
    ScrollText,
    Settings,
    LifeBuoy,
} from "lucide-react";

export const NAV_GROUPS = [
    {
        label: "Overview",
        items: [{ id: "dashboard", label: "Dashboard", path: "/app/dashboard", icon: LayoutDashboard }],
    },
    {
        label: "Intelligence",
        items: [
            { id: "product-brain", label: "Product Brain", path: "/app/product-brain", icon: Boxes },
            {
                id: "inventory-intelligence",
                label: "Inventory Intelligence",
                path: "/app/inventory-intelligence",
                icon: LineChart,
            },
            { id: "customer-brain", label: "Customer Brain", path: "/app/customer-brain", icon: Users },
            { id: "supplier-brain", label: "Supplier Brain", path: "/app/supplier-brain", icon: Truck },
            { id: "yug-brain", label: "Yug Brain", path: "/app/yug-brain", icon: Sparkles, aiAccent: true },
        ],
    },
    {
        label: "Operations",
        items: [
            { id: "warehouse-hub", label: "Warehouse Hub", path: "/app/warehouse-hub", icon: Warehouse },
            { id: "sales-hub", label: "Sales Hub", path: "/app/sales-hub", icon: ShoppingBag },
            { id: "procurement", label: "Procurement", path: "/app/procurement", icon: ShoppingCart },
        ],
    },
    {
        label: "Finance",
        items: [
            { id: "billing", label: "Billing", path: "/app/billing", icon: Receipt },
            { id: "finance-hub", label: "Finance Hub", path: "/app/finance-hub", icon: Wallet },
            { id: "business-intelligence", label: "Business Intelligence", path: "/app/business-intelligence", icon: BarChart3 },
        ],
    },
    {
        label: "System",
        items: [
            { id: "user-management", label: "User Management", path: "/app/user-management", icon: UserCog, adminOnly: true },
            { id: "audit-logs", label: "Audit Logs", path: "/app/audit-logs", icon: ScrollText, adminOnly: true },
            { id: "settings", label: "Settings", path: "/app/settings", icon: Settings },
            { id: "help", label: "Help", path: "/app/help", icon: LifeBuoy },
        ],
    },
];

export const MODULE_META = {
    dashboard: { title: "Dashboard", description: "The 30-second view of your business." },
    "product-brain": {
        title: "Product Brain",
        description: "A unified intelligence layer for every SKU — pricing, movement, and margins.",
    },
    "inventory-intelligence": {
        title: "Inventory Intelligence",
        description: "Predictive stock signals to prevent stockouts and over-purchase.",
    },
    "warehouse-hub": {
        title: "Warehouse Hub",
        description: "Bin-level visibility, receiving, and dispatch operations.",
    },
    "customer-brain": {
        title: "Customer Brain",
        description: "Buying patterns, lifetime value, and relationship intelligence.",
    },
    "supplier-brain": {
        title: "Supplier Brain",
        description: "Supplier reliability scoring, lead times, and negotiation intelligence.",
    },
    "sales-hub": {
        title: "Sales Hub",
        description: "Orders, quotes, and the daily rhythm of your sales team.",
    },
    billing: { title: "Billing", description: "Invoicing, credit terms, and receivables." },
    "finance-hub": {
        title: "Finance Hub",
        description: "Cashflow, ledgers, and the financial nervous system of the business.",
    },
    procurement: {
        title: "Procurement",
        description: "Purchase orders, GRNs, and supplier onboarding.",
    },
    "business-intelligence": {
        title: "Business Intelligence",
        description: "Composable analytics with global filters — sales, product, inventory, customer, supplier, procurement, and executive views.",
    },
    "yug-brain": {
        title: "Yug Brain",
        description: "The AI copilot that answers questions and surfaces what needs attention.",
    },
    "user-management": {
        title: "User Management",
        description: "Create users, assign roles, and manage access across the organisation.",
    },
    "audit-logs": {
        title: "Audit Logs",
        description: "Every meaningful action, attributed and time-stamped.",
    },
    settings: { title: "Settings", description: "Workspace, appearance, security, and integrations." },
    help: { title: "Help", description: "Documentation, shortcuts, and support." },
};

export const ROLES = [
    { value: "owner", label: "Owner" },
    { value: "administrator", label: "Administrator" },
    { value: "manager", label: "Manager" },
    { value: "sales", label: "Sales" },
    { value: "warehouse", label: "Warehouse" },
    { value: "billing", label: "Billing" },
    { value: "accounts", label: "Accounts" },
    { value: "procurement", label: "Procurement" },
];

export const ADMIN_ROLES = ["owner", "administrator"];
